<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      :pageSize="page.pageSize"
      :pageSizes="[50, 100, 200]"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    >
      <el-table-column label="订单号" slot="orderNo" align="center">
        <template slot-scope="{ row }">
          <span class="order-link" @click="handleOrderClick(row)">{{ row.orderNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="放款状态" slot="loanStatus" align="center">
        <template slot-scope="{ row }">
          <span :class="getLoanStatusClass(row.transferStatus)">{{ formatTransferStatus(row.transferStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款金额" slot="amount" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.amount }}元</span>
        </template>
      </el-table-column>
    </GlobalTable>
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";

export default {
  inject: ["reload"],
  name: "Table",
  mixins: [MinXinRequest],
  data() {
    return {
      loading: false,
      seachDataList: [],
      tableColumns: [
        // { label: "序号", prop: "index", width: 70 },
        { slotName: "orderNo" },
        { label: "出账单号", prop: "transferNo" },
        { slotName: "loanStatus" },
        { label: "收款人", prop: "withdrawUser" },
        { label: "用户手机号", prop: "withdrawUserMobile" },
        { slotName: "amount" },
        { label: "操作人", prop: "resetUser" },
        { label: "操作时间", prop: "resetTime", width: 160 },
      ],
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    this.handleCurrentChange();
  },
  watch: {
    SeachParams() {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const params = {
        orderNo: this.SeachParams.orderNo,
        transferNo: this.SeachParams.transferNo,
        resetTimeFrom: this.SeachParams.resetTimeFrom,
        resetTimeTo: this.SeachParams.resetTimeTo,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api
        .getAbnormalPaymentRecordList(params)
        .then((res) => {
          if (res.code === 1) {
            const records = res.data.records || [];
            records.forEach((item, index) => {
              item.index = (this.page.pageNum - 1) * this.page.pageSize + index + 1;
            });
            this.seachDataList = records;
            this.page.total = res.data.total;
            this.page.pageNum = res.data.current;
          }
        })
        .finally(() => {
          this.loading = false;
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
    handleOrderClick(row) {
      const route = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { id: row.orderNo ,type: "edit",},
      });
      window.open(route.href, "_blank");
    },
    formatTransferStatus(status) {
      const map = {
        1: "待审核",
        2: "放款中",
        3: "已驳回",
        4: "放款成功",
        5: "放款失败",
        6: "已失效",
        7: "微信异常",
      };
      return map[status] || status;
    },
    getLoanStatusClass(status) {
      const text = this.formatTransferStatus(status);
      if (text === "放款中") return "status-pending";
      if (text === "放款成功") return "status-success";
      if (["放款失败", "已驳回", "已失效", "微信异常"].includes(text)) return "status-fail";
      return "";
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .order-link {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  .status-pending {
    color: #e6a23c;
  }

  .status-success {
    color: #67c23a;
  }

  .status-fail {
    color: #f56c6c;
  }
}
</style>
